/**
 * @generated SignedSource<<bcc6d9e465ca4baa6ab4b642aaf744c5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiPresetsQuery$variables = {
  categoryId?: number | null;
  presetType?: string | null;
  toolId: string;
};
export type aiPresetsQuery$data = {
  readonly aiPresets: ReadonlyArray<{
    readonly categoryId: string | null;
    readonly categoryName: string | null;
    readonly description: string | null;
    readonly factor: number | null;
    readonly id: string;
    readonly imageUrl: string | null;
    readonly name: string;
    readonly negativePrompt: string | null;
    readonly presetType: string | null;
    readonly previewUrl: string | null;
    readonly prompt: string | null;
    readonly sellerID: number | null;
    readonly sortOrder: number;
  }>;
};
export type aiPresetsQuery = {
  response: aiPresetsQuery$data;
  variables: aiPresetsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "presetType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "toolId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "categoryId",
        "variableName": "categoryId"
      },
      {
        "kind": "Variable",
        "name": "presetType",
        "variableName": "presetType"
      },
      {
        "kind": "Variable",
        "name": "toolId",
        "variableName": "toolId"
      }
    ],
    "concreteType": "AIPresetDTO",
    "kind": "LinkedField",
    "name": "aiPresets",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "presetType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoryId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoryName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "prompt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "negativePrompt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "factor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sortOrder",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "previewUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sellerID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiPresetsQuery",
    "selections": (v3/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "aiPresetsQuery",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "9093a6c6582dab71dd4e9dea95fab126",
    "id": null,
    "metadata": {},
    "name": "aiPresetsQuery",
    "operationKind": "query",
    "text": "query aiPresetsQuery(\n  $toolId: String!\n  $presetType: String\n  $categoryId: Int\n) {\n  aiPresets(toolId: $toolId, presetType: $presetType, categoryId: $categoryId) {\n    id\n    name\n    presetType\n    categoryId\n    categoryName\n    prompt\n    negativePrompt\n    imageUrl\n    factor\n    description\n    sortOrder\n    previewUrl\n    sellerID\n  }\n}\n"
  }
};
})();

(node as any).hash = "353b238cf48de68c9bf6947e6d7eb53a";

export default node;
